export const httpVerbs = [
    'get',
    'post',
    'put',
    'patch',
    'head',
    'delete',
    'options',
    'connect',
    'trace',
];
